<template>
  <div class="service detail wrap">
    <div class="text-bg otp">
      <div class="text-wrap">
        <p>{{ $t('solution.detail.twoFactor.lineText.01') }}</p>
        <p>{{ $t('solution.detail.twoFactor.lineText.02') }}</p>
        <p>{{ $t('solution.detail.twoFactor.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="otp title">
      <template #half-left>
        <div class="img otp"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('solution.title.twoFactor') }}
            </h3>
            <h6>Two Factor Authentication</h6>
            <h4>{{ $t('solution.detail.twoFactor.subTitle') }}</h4>
          </div>
          <h5>{{ $t('solution.detail.twoFactor.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="otp summary">
      <template #half-left>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.twoFactor.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:lock-open-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.twoFactor.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.twoFactor.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:apple-podcasts-logo-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.twoFactor.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.twoFactor.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:circles-three-plus-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.twoFactor.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.twoFactor.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <section class="section otp benefit">
      <h2 class="hl section-title">{{ $t('solution.detail.twoFactor.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="inner-contents">
          <div class="contents-list">
            <dl data-aos="zoom-in">
              <div class="img otp"></div>
              <dt>{{ $t('solution.detail.twoFactor.benefit.contents.01.title') }}</dt>
              <dd>{{ $t('solution.detail.twoFactor.benefit.contents.01.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img otp"></div>
              <dt>{{ $t('solution.detail.twoFactor.benefit.contents.02.title') }}</dt>
              <dd>{{ $t('solution.detail.twoFactor.benefit.contents.02.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img otp"></div>
              <dt>{{ $t('solution.detail.twoFactor.benefit.contents.03.title') }}</dt>
              <dd>{{ $t('solution.detail.twoFactor.benefit.contents.03.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img otp"></div>
              <dt>{{ $t('solution.detail.twoFactor.benefit.contents.04.title') }}</dt>
              <dd>{{ $t('solution.detail.twoFactor.benefit.contents.04.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img otp"></div>
              <dt>{{ $t('solution.detail.twoFactor.benefit.contents.05.title') }}</dt>
              <dd>{{ $t('solution.detail.twoFactor.benefit.contents.05.desc') }}</dd>
            </dl>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'SolutionDetailTwoFactor',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
